import React, { useState, useEffect } from "react";
import "./pourquoinous.css";
import { useNavigate } from "react-router-dom"; // Ajoute cet import
import Breadcrumb from './Breadcrumb';
import CallToAction from './CallToAction';
import backgroundImage from '../assets/whyus.png';
import { FaGlobe, FaChartLine, FaHandsHelping } from 'react-icons/fa';

const PourquoiNous = () => {
    const navigate = useNavigate(); // Ajoute ce hook
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        nom: "",
        email: "",
        telephone: "",
        entreprise: "",
        message: ""
    });

    // // Données statiques pour les valeurs
    // const sectionTitle = "Pourquoi nous choisir ?";
    // const sectionSubtitle = "Nous sommes le partenaire stratégique pour vos projets.";

    // const values = [
    //     {
    //         id: 1,
    //         title: "Expertise & Référentiels Internationaux",
    //         description: "Nous intervenons à l'intersection de l'expérience terrain et des standards internationaux en gestion de projet. Nos approches s'appuient sur des référentiels reconnus, adaptés aux réalités opérationnelles des organisations.",
    //         imageUrl: "",
    //         imageAlt: "Expertise"
    //     },
    //     {
    //         id: 2,
    //         title: "Impact Mesurable sur la Performance",
    //         description: "Au-delà de la formation, nous contribuons à améliorer concrètement la performance des projets : meilleure maîtrise des délais, des coûts et des risques, avec des pratiques structurées et durables.",
    //         imageUrl: "",
    //         imageAlt: "Impact Mesurable"
    //     },
    //     {
    //         id: 3,
    //         title: "Accompagnement de Bout en Bout",
    //         description: "Du diagnostic à la montée en compétence certifiante, nous accompagnons entreprises et professionnels avec exigence et rigueur, jusqu'à l'atteinte des résultats attendus.",
    //         imageUrl: "",
    //         imageAlt: "Accompagnement"
    //     }
    // ];

    // États pour les chiffres clés animés
    const [chiffresCles, setChiffresCles] = useState([
        {
            id: 1,
            valeur: 18,
            unite: "ans",
            description: "d'expérience",
            details: "2 antennes à Cotonou & Lomé et des interventions dans la sous-région",
            animatedValue: 0
        },
        {
            id: 2,
            valeur: 10,
            unite: "ans",
            description: "de Partenariat officiel avec le PMI",
            details: "en tant que ATP Premium (anciennement REP)",
            animatedValue: 0
        },
        {
            id: 3,
            valeur: 1000,
            unite: "+",
            description: "professionnels formés",
            details: "sur les métiers de la gestion de projet, du leadership et de la performance organisationnelle",
            animatedValue: 0
        }
    ]);

    // Récupération des données depuis l'API (commentée pour l'instant)
    // useEffect(() => {
    //   fetchProjectsExcellenceData();
    // }, []);

    // const fetchProjectsExcellenceData = async () => {
    //   try {
    //     setLoading(true);
    //     const response = await fetch('http://localhost/ivtcms/api/rubriques/by-url/Des-projets-menes-a-l-excellence');
    //     const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Des-projets-menes-a-l-excellence`,)
    //     
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! status: ${response.status}`);
    //     }
    //     
    //     const data = await response.json();
    //     
    //     if (data.success && data.data) {
    //       const rubriqueData = data.data;
    //       
    //       if (rubriqueData.articles && rubriqueData.articles.length > 0) {
    //         const formattedValues = rubriqueData.articles.map((article) => {
    //           let imageUrl = "";
    //           let imageAlt = article.titre || "";
    //           
    //           if (article.documents && article.documents.length > 0) {
    //             const firstImage = article.documents.find(doc => 
    //               doc.type === 'image' || doc.extension?.match(/(jpg|jpeg|png|gif|webp|svg)$/i)
    //             );
    //             if (firstImage) {
    //               imageUrl = firstImage.url;
    //               imageAlt = firstImage.titre || article.titre;
    //             }
    //           }
    //           
    //           return {
    //             id: article.id_article,
    //             title: article.titre || "",
    //             description: article.soustitre || "",
    //             imageUrl: imageUrl,
    //             imageAlt: imageAlt
    //           };
    //         });
    //       }
    //     } else {
    //       throw new Error('Données de rubrique non disponibles');
    //     }
    //     
    //   } catch (err) {
    //     console.error('Erreur lors de la récupération des données:', err);
    //     setError(err.message);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // États pour les données dynamiques
    const [sectionTitle, setSectionTitle] = useState("Pourquoi-nous choisir ?");
    const [sectionSubtitle, setSectionSubtitle] = useState("Nous sommes le partenaire stratégique pour vos projets.");
    const [values, setValues] = useState([]);

    // États pour les chiffres clés (statistiques)
    const [statsTitle, setStatsTitle] = useState("Pourquoi-nous faire confiance ?");
    const [statsSubtitle, setStatsSubtitle] = useState("Avec plus de 10 ans d'expérience dans la préparation aux certifications PMI, nous avons accompagné plus de 1000 professionnels.");
    const [statsData, setStatsData] = useState([]);
    const [animatedStats, setAnimatedStats] = useState([]);

    // Fonction pour nettoyer le HTML
    const cleanText = (html) => {
        if (!html) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    };

    // Extraire la valeur numérique d'une chaîne (ex: "18 ans" -> 18)
    const extractNumericValue = (str) => {
        if (!str) return 0;
        const match = str.match(/(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
    };

    // Extraire le suffixe (ex: "18 ans" -> "ans", "1000+" -> "+")
    const extractSuffix = (str) => {
        if (!str) return '';
        const match = str.match(/\d+(.*)/);
        return match ? match[1] : '';
    };

    // Récupérer les données depuis l'API pour les valeurs
    useEffect(() => {
        fetchAllData();
    }, []);

    const fetchAllData = async () => {
        try {
            setLoading(true);

            // 1. Récupérer les valeurs (Des projets menés à l'excellence)
            const valuesResponse = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Pourquoi-nous`);

            if (valuesResponse.ok) {
                const valuesData = await valuesResponse.json();
                if (valuesData.success && valuesData.data) {
                    const rubriqueData = valuesData.data;

                    setSectionTitle(cleanText(rubriqueData.titre) || "Pourquoi nous choisir ?");
                    setSectionSubtitle(cleanText(rubriqueData.soustitre) || "Nous sommes le partenaire stratégique pour vos projets.");

                    if (rubriqueData.articles && rubriqueData.articles.length > 0) {
                        const formattedValues = rubriqueData.articles.map((article) => ({
                            id: article.id_article,
                            title: cleanText(article.titre) || "",
                            description: cleanText(article.soustitre) || cleanText(article.descriptif) || "",
                            // imageUrl: article.documents?.[0]?.url || "",
                            // imageAlt: article.titre || ""
                        }));
                        setValues(formattedValues);
                    }
                }
            }

            // 2. Récupérer les chiffres clés (statistiques)
            const statsResponse = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Pourquoi-faire-confiance`);

            if (statsResponse.ok) {
                const statsDataJson = await statsResponse.json();
                if (statsDataJson.success && statsDataJson.data) {
                    const rubriqueStats = statsDataJson.data;

                    setStatsTitle(cleanText(rubriqueStats.titre) || "Pourquoi-nous faire confiance ?");
                    setStatsSubtitle(cleanText(rubriqueStats.soustitre) || "Avec plus de 10 ans d'expérience dans la préparation aux certifications PMI, nous avons accompagné plus de 1000 professionnels.");

                    if (rubriqueStats.articles && rubriqueStats.articles.length > 0) {
                        const formattedStats = rubriqueStats.articles.map((article, index) => {
                            const valeurText = cleanText(article.titre) || "";
                            const valeur = extractNumericValue(valeurText);
                            const unite = extractSuffix(valeurText);

                            return {
                                id: article.id_article,
                                valeur: valeur,
                                unite: unite,
                                description: cleanText(article.soustitre) || "",
                                details: cleanText(article.descriptif) || "",
                                animatedValue: 0
                            };
                        });
                        setStatsData(formattedStats);
                        setAnimatedStats(formattedStats.map(stat => ({ ...stat, animatedValue: 0 })));
                    } else {
                        // Données par défaut
                        // setDefaultStats();
                    }
                } else {
                    // setDefaultStats();
                }
            } else {
                // setDefaultStats();
            }

        } catch (err) {
            console.error('Erreur lors de la récupération des données:', err);
            setError(err.message);
            // setDefaultStats();
        } finally {
            setLoading(false);
        }
    };

    // const setDefaultStats = () => {
    //     const defaultStats = [
    //         {
    //             id: 1,
    //             valeur: 18,
    //             unite: "ans",
    //             description: "d'expérience",
    //             details: "2 antennes à Cotonou & Lomé et des interventions dans la sous-région",
    //             animatedValue: 0
    //         },
    //         {
    //             id: 2,
    //             valeur: 10,
    //             unite: "ans",
    //             description: "de Partenariat officiel avec le PMI",
    //             details: "en tant que ATP Premium (anciennement REP)",
    //             animatedValue: 0
    //         },
    //         {
    //             id: 3,
    //             valeur: 1000,
    //             unite: "+",
    //             description: "professionnels formés",
    //             details: "sur les métiers de la gestion de projet, du leadership et de la performance organisationnelle",
    //             animatedValue: 0
    //         }
    //     ];
    //     setStatsData(defaultStats);
    //     setAnimatedStats(defaultStats);
    // };

    // Initialisation - utiliser les données statiques
    useEffect(() => {
        setLoading(false);
    }, []);

    // Animation des chiffres clés
    useEffect(() => {
        if (!loading) {
            const duration = 2000;
            const intervalTime = 20;

            chiffresCles.forEach((chiffre, index) => {
                const targetValue = chiffre.valeur;
                const steps = duration / intervalTime;
                let currentStep = 0;

                const interval = setInterval(() => {
                    currentStep++;
                    const progress = currentStep / steps;
                    const animatedValue = Math.round(progress * targetValue);

                    setChiffresCles(prev => {
                        const newChiffres = [...prev];
                        if (newChiffres[index]) {
                            newChiffres[index] = {
                                ...newChiffres[index],
                                animatedValue: Math.min(animatedValue, targetValue)
                            };
                        }
                        return newChiffres;
                    });

                    if (currentStep >= steps) {
                        clearInterval(interval);
                        setChiffresCles(prev => {
                            const newChiffres = [...prev];
                            if (newChiffres[index]) {
                                newChiffres[index] = {
                                    ...newChiffres[index],
                                    animatedValue: targetValue
                                };
                            }
                            return newChiffres;
                        });
                    }
                }, intervalTime);

                return () => clearInterval(interval);
            });
        }
    }, [loading]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Formulaire soumis:", formData);
        alert("Merci ! Nous vous contacterons rapidement.");
        setIsModalOpen(false);
        setFormData({
            nom: "",
            email: "",
            telephone: "",
            entreprise: "",
            message: ""
        });
    };

    // Fonction pour gérer la redirection vers la page contact
    const handleContactClick = () => {
        navigate("/contactez-nous#form"); // Redirige vers la page /contact
    };

    if (loading) {
        return (
            <>
                <Breadcrumb />
                <div className="pourquoi-loading-container">
                    <div className="pourquoi-spinner"></div>
                    <p>Chargement...</p>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Breadcrumb />
                <div className="pourquoi-error-container">
                    <p>Erreur : {error}</p>
                    <button onClick={() => window.location.reload()}>Réessayer</button>
                </div>
            </>
        );
    }

    return (
        <>
            <Breadcrumb />
            <div className="pourquoi-page">
                {/* Hero Section */}
                <div className="pourquoi-page-hero">
                    <img
                        src={backgroundImage}
                        alt="Background"
                        className="entreprise-page-hero-bg"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                    <div className="pourquoi-page-hero-overlay"></div>
                    <div className="pourquoi-page-hero-content">
                        <h1 className="pourquoi-page-hero-title">Pourquoi-nous ?</h1>
                        <p className="pourquoi-page-hero-subtitle">
                            Nous sommes le partenaire stratégique pour vos projets
                        </p>
                        <div className="pourquoi-page-hero-buttons">
                            {/* <button className="pourquoi-page-hero-btn primary" >
                                Prendre rendez-vous
                            </button> */}
                            <button className="pourquoi-page-hero-btn secondary" onClick={handleContactClick}>
                                Prendre rendez-vous
                            </button>
                        </div>
                    </div>
                </div>

                {/* Section Valeurs - 3 blocs */}
                <section className="pourquoi-values-section">
                    <div className="pourquoi-values-container">
                        <h2 className="pourquoi-values-title">Pourquoi-nous choisir ?</h2>
                        <p className="pourquoi-values-subtitle">
                            Notre engagement pour votre réussite
                        </p>

                        <div className="pourquoi-three-blocks-container">
                            {values.map((value, index) => (
                                <div key={value.id} className="pourquoi-values-block">
                                    <div className="pourquoi-values-block-content">
                                        <div className="pourquoi-values-header">
                                            <h3 className="pourquoi-values-item-title">{value.title}</h3>

                                            {/* Icône */}
                                            <div className="pourquoi-values-icon-container">
                                                <div className="pourquoi-values-icon">
                                                    {index === 0 && (
                                                        <>
                                                            <svg width="45" height="45" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M12 2L2 7L12 12L22 7L12 2Z"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M2 17L12 22L22 17"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M2 12L12 17L22 12"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M12 12V22"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>

                                                            {/* <FaGlobe size={45}/> */}

                                                        </>
                                                    )}
                                                    {index === 1 && (
                                                        <>
                                                            <svg width="45" height="45" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M21 21H4V4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M7 14L10 11L13 13L18 7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                {/* <circle cx="7" cy="14" r="1.5" stroke="white" strokeWidth="1.5" />
                                                                <circle cx="10" cy="11" r="1.5" stroke="white" strokeWidth="1.5" />
                                                                <circle cx="13" cy="13" r="1.5" stroke="white" strokeWidth="1.5" />
                                                                <circle cx="18" cy="7" r="1.5" stroke="white" strokeWidth="1.5" /> */}
                                                            </svg>

                                                            {/* <FaChartLine  size={45}/> */}

                                                        </>
                                                    )}
                                                    {index === 2 && (
                                                        <>
                                                            {/* <svg width="45" height="45" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M12 6V12L16 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg> */}

                                                            <FaHandsHelping size={45} />

                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <p className="pourquoi-values-description">{value.description}</p>

                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Chiffres Clés Section avec animation */}
                <div className="pourquoi-page-chiffres">
                    <div className="pourquoi-page-section-content">

                        <h2 className="pourquoi-values-title">{statsTitle}</h2>
                        <p className="pourquoi-values-subtitle">{statsSubtitle}</p>
                        <div className="pourquoi-page-chiffres-grid">
                            {chiffresCles.map((chiffre) => (
                                <div key={chiffre.id} className="pourquoi-page-chiffre-card">
                                    <div className="chiffre-valeur">
                                        {chiffre.animatedValue}
                                        {chiffre.unite && <span className="chiffre-unite">{chiffre.unite}</span>}
                                    </div>
                                    <div className="pourquoi-ligne"></div>
                                    <div className="chiffre-description">{chiffre.description}</div>
                                    <div className="chiffre-details">{chiffre.details}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Call to Action Footer */}
                {/* <div className="pourquoi-page-cta-footer">
                    <div className="pourquoi-page-cta-footer-content">
                        <h2>Prêt à collaborer avec nous ?</h2>
                        <div className="pourquoi-page-footer-buttons">
                            <button className="footer-btn primary" >
                                Prendre rendez-vous
                            </button>
                            <button className="footer-btn secondary" onClick={handleContactClick}>
                                Nous contacter
                            </button>
                        </div>
                    </div>
                </div> */}

                <CallToAction
                    title="Prêt à collaborer avec nous ?"
                    // button1Text="Prendre rendez-vous"
                    button2Text="Prendre rendez-vous"
                    // onButton1Click={handleContactClick}
                    onButton2Click={handleContactClick}
                    // button1Icon={<FaWhatsapp />}
                />

                {/* Modal Formulaire */}
                {isModalOpen && (
                    <div className="pourquoi-page-modal-overlay" onClick={() => setIsModalOpen(false)}>
                        <div className="pourquoi-page-modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="pourquoi-page-modal-close" onClick={() => setIsModalOpen(false)}>✕</button>
                            <h2>Nous contacter</h2>
                            <p>Remplissez ce formulaire et nous vous répondrons dans les plus brefs délais</p>

                            <form onSubmit={handleSubmit} className="pourquoi-page-form">
                                <div className="pourquoi-page-form-group">
                                    <label>Nom complet *</label>
                                    <input
                                        type="text"
                                        name="nom"
                                        value={formData.nom}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Votre nom"
                                    />
                                </div>

                                <div className="pourquoi-page-form-group">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="votre@email.com"
                                    />
                                </div>

                                <div className="pourquoi-page-form-group">
                                    <label>Téléphone</label>
                                    <input
                                        type="tel"
                                        name="telephone"
                                        value={formData.telephone}
                                        onChange={handleInputChange}
                                        placeholder="Votre numéro"
                                    />
                                </div>

                                <div className="pourquoi-page-form-group">
                                    <label>Entreprise</label>
                                    <input
                                        type="text"
                                        name="entreprise"
                                        value={formData.entreprise}
                                        onChange={handleInputChange}
                                        placeholder="Nom de votre entreprise"
                                    />
                                </div>

                                <div className="pourquoi-page-form-group">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        rows="4"
                                        placeholder="Votre message..."
                                    ></textarea>
                                </div>

                                <button type="submit" className="pourquoi-page-submit-button">
                                    Envoyer le message
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default PourquoiNous;